/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    SSRV2RuleOrderValue,
    SSRV2RuleOrderValueFromJSON,
    SSRV2RuleOrderValueFromJSONTyped,
    SSRV2RuleOrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleQuery
 */
export interface SSRV2RuleQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRV2RuleQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleQuery
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {SSRV2RuleOrderValue}
     * @memberof SSRV2RuleQuery
     */
    orderValue?: SSRV2RuleOrderValue;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof SSRV2RuleQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {number}
     * @memberof SSRV2RuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SSRV2RuleQuery
     */
    limit?: number | null;
}

export function SSRV2RuleQueryFromJSON(json: any): SSRV2RuleQuery {
    return SSRV2RuleQueryFromJSONTyped(json, false);
}

export function SSRV2RuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : SSRV2RuleOrderValueFromJSON(json['orderValue']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SSRV2RuleQueryToJSON(value?: SSRV2RuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'description': value.description,
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'orderByDescending': value.orderByDescending,
        'orderValue': SSRV2RuleOrderValueToJSON(value.orderValue),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'offset': value.offset,
        'limit': value.limit,
    };
}


